/** @jsxImportSource @emotion/react */
import { Button, Container } from "@coreai/component-library";
import { css, useTheme } from "@emotion/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../LanguageContext";

interface NoProjectsCardProps {
  setNewProject: (set: boolean) => void;
}

export default function NoProjectsCard(props: Readonly<NoProjectsCardProps>) {
  const { t } = useLanguage();
  const theme = useTheme();
  const navigate = useNavigate();
  const containerStyle = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${theme.colors.white};
    box-shadow: ${theme.shadows.shallow};
    padding: ${theme.spacing.xxxl};
    text-align: center;
    border-radius: ${theme.radius.sm};
    color: ${theme.colors.textMedium};
    margin: 40px 0;
  `;

  const flexStyle = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${theme.spacing.xxl};
  `;

  const bodyStyle = {
    fontFamily: theme.typography.bodyMedium.fontFamily,
    fontSize: theme.typography.bodyMedium.fontSize,
    fontWeight: theme.typography.bodyMedium.fontWeight,
    lineHeight: theme.typography.bodyMedium.lineHeight,
    color: theme.colors.textDark,
  } as React.CSSProperties;

  const bodySemiBoldStyle = {
    fontFamily: theme.typography.heading3_medium.fontFamily,
    fontSize: theme.typography.heading3_medium.fontSize,
    fontWeight: theme.typography.heading3_medium.fontWeight,
    lineHeight: theme.typography.heading3_medium.lineHeight,
    color: theme.colors.textDark,
    marginTop: theme.spacing.lg,
  } as React.CSSProperties;

  return (
    <Container variant="column" css={containerStyle}>
      <div css={flexStyle}>
        <div style={bodySemiBoldStyle}>
          <div>{t("project_noProjectCard_title")}</div>
        </div>
        <div style={bodyStyle}>
          <div>{t("project_noProjectCard_paragraph")}</div>
        </div>
        <Button
          variant={"secondary"}
          icon={"plus"}
          color={theme.colors.primary}
          onClick={() => navigate('/projects/new')}
          // className="brandPrimaryBtn"
        >
          {t("project_noProjectCard_actionButton")}
        </Button>
      </div>
    </Container>
  );
}
